import { CompetencyMapQuery } from "@generated/graphql";
import { SkillOption } from "./components/types";

type SkillsMap = Record<string, Omit<SkillOption, "id">>;

// eslint-disable-next-line import/prefer-default-export
export const extractSkills = (competencyMap: CompetencyMapQuery["competencyMap"]): SkillsMap => {
  if (!competencyMap?.competences) return {};

  const skillsEntries = competencyMap.competences.flatMap((competence) => {
    const knowledgeBlocks = competence.knowledgeBlockCompetences || [];

    return knowledgeBlocks.flatMap((knowledgeBlock) => {
      const skills = knowledgeBlock.knowledgeBlock?.skills || [];
      return skills.map(({ id, title }) => [id, { title }]);
    });
  });

  return Object.fromEntries(skillsEntries);
};
